<template>
  <div >    
   
          <div class="formBox" v-if="showForm">
              <span class="t">{{addForm.id?'编辑':'新增'}}巡检点</span>
              <el-divider></el-divider>
                  <el-form ref="addForm" class="searchForm" :rules="rules" :model="addForm" label-width="80px">
                        <el-form-item label="设备名称" prop="equipmentName" size="mini">
                          <el-input v-model="addForm.equipmentName"  placeholder="请输入设备名称"></el-input>
                        </el-form-item>
                        <el-form-item label="设备类型" prop="equipmentType" size="mini">
                            <el-select v-model="addForm.equipmentType" placeholder="请选择" style="whith:100%">
                            <el-option
                              v-for="(item, index) in equipmentTypeList"
                              :key="index"
                              :label="item.name"
                              :value='Number(item.code)'
                            ></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="规格型号" prop="equipmentSpecifications" size="mini">
                          <el-input v-model="addForm.equipmentSpecifications" placeholder="请输入规格型号"></el-input>
                        </el-form-item>
                        <el-form-item label="设备状态" prop="equipmentStatus" size="mini">
                          <el-select v-model="addForm.equipmentStatus" placeholder="请选择" style="whith:100%">
                            <el-option
                              v-for="(item, index) in equipmentStatusList"
                              :key="index"
                              :label="item.name"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>     
                        <el-form-item label="生产日期" prop="equipmentTime" size="mini">
                          <el-date-picker
                            v-model="addForm.equipmentTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>   
                        <el-form-item label="使用日期" prop="equipmentUseTime" size="mini">
                           <el-date-picker
                            v-model="addForm.equipmentUseTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>   
                        <el-form-item label="所属部门" prop="equipmentDepartmentId" size="mini">
                          <el-cascader
                              placeholder="请选择所属部门"
                              v-model="addForm.equipmentDepartmentId"
                              :options="equipmentoptions"
                              :props="{ expandTrigger: 'hover',value:'id',label:'name' }"
                          ></el-cascader>
<!--                          <el-input v-model="addForm.equipmentDepartmentId" placeholder="请输入所属部门"></el-input>-->
                        </el-form-item>  
                        <el-form-item label="生产商" prop="equipmentProducers" size="mini">
                          <el-input v-model="addForm.equipmentProducers" placeholder="请输入生产商"></el-input>
                        </el-form-item>
                    <el-form-item label="关联管线" prop="lineId" size="mini">
                      <el-select filterable  clearable v-model="addForm.lineId" placeholder="请选择" style="whith:100%">
                        <el-option
                            v-for="(item, index) in allline"
                            :key="index"
                            :label="item.lineName"
                            :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="所在地址" prop="equipmentHome" size="mini">
                          {{addForm.equipmentHome}}                 
                        </el-form-item>      
                        <el-form-item label-width="0px" class="searchBt">
                          <el-button
                            size="mini"
                            type="primary"
                            class="searchBtn"
                            @click="save"
                            >保存</el-button
                          >
                          <el-button
                            size="mini"
                            class="searchBtn"
                            @click="closePDraw"
                            >取消</el-button
                          >
                        </el-form-item>
                  </el-form>
          </div>

  </div>
</template>

<script>
import {lineList} from '@/RequestPort/gis/index'
import {saveEquipment,selectDictListByParentCode } from '@/apis/commonType'
import { geoOws } from '@/apis/geo'
import {selectSysDeptTreeList} from "../../../RequestPort/user/user";
export default {
  name: 'formEdit',
  props:{
    showForm:{
      type:Boolean,
      default:false
    },     
    addForm:{
      type:Object,
      default: function(){
        return {}
        }
    },
    polyline1:{
      type:Object,
      default: null
    }
  },
  data() {
    return {
      allline:[],
      name: '片区',
     equipmentStatusList:[{name:'停用',value:0},{name:'在用',value:1},{name:'废弃',value:2}],
      equipmentTypeList:[],
      equipmentoptions:[],
      rules: {
        equipmentName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' },
          { min: 0, max: 100, message: '长度在 0 到 100 个字符', trigger: 'blur' }
        ],
        equipmentSpecifications: [
          { required: true, message: '请输入规格型号', trigger: 'blur' },
          { min: 0, max: 100, message: '长度在 0 到 100 个字符', trigger: 'blur' }
        ],
        equipmentTime: [
          { required: true, message: '请选择生产日期', trigger: 'change' }
        ],
        equipmentType: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        equipmentStatus: [
          { required: true, message: '请选择设备状态', trigger: 'change' }
        ],
        equipmentDepartmentId:[
          { required: true, message: '请选择部门', trigger: 'change' }
        ],

      },
    }
  },
  computed: {},
  mounted() {
    // lineList().then((e)=>{
    //   this.allline = e.data
    // })
    selectDictListByParentCode({parentCode:20000}).then(res => {
         if(res.code==200){
           this.equipmentTypeList=res.data
         }
      })
    selectSysDeptTreeList({deptListShow:'y'}).then((e)=>{
      this.equipmentoptions = e.data
    })
  },
  methods: {
    resetFields(){
      if(this.$refs['addForm']){
        this.$refs['addForm'].resetFields()
      }
     
    },
    save(){
      // if(this.polyline1){
      //     this.addForm.location=this.polyline1.getPath()
      // }
      this.$refs['addForm'].validate(valid => {
          if (valid) {   
            this.getNetwork()
          }
      })
      
    },
    getNetwork(){
      let file=this.getfile(this.addForm.locations)
      let parames={
          service:'WFS',
          request:'GetFeature',
          typeName:'gas:patrol_networks',
          maxFeatures:'50',
          outputFormat:'application/json',
          version:'1.0.0',
          filter:file
      }
      
      geoOws(parames).then(res => {
        if(res.features&&res.features[0]){
         this.addForm.networkId=res.features[0].properties.id
        }         
         this.saveApi()
      })
    },
    saveApi(){
         let parames=this.addForm
               parames.lng=this.addForm.locations[0]
               parames.lat=this.addForm.locations[1]
                parames.equipmentDepartmentId = this.addForm.equipmentDepartmentId[this.addForm.equipmentDepartmentId.length-1]
                saveEquipment(parames).then(res => {
                if(res.code==200){
                  this.$message.success('操作成功')
                  this.$emit('save')
                }                
              })
    },
    getfile(lnglat){
      let file='<Filter xmlns:gml="http://www.opengis.net/gml">'+
                       ' <And>   <PropertyIsGreaterThan>'+
                        '  <PropertyName>general_status</PropertyName>'+
                         ' <Literal>0</Literal>'+
                        ' </PropertyIsGreaterThan> <Intersects>'+
                        ' <PropertyName>location</PropertyName>'+
                      '   <gml:Point>'+
                            '  <gml:coordinates>'+lnglat[0]+','+lnglat[1]+'</gml:coordinates>'+
                        ' </gml:Point>'+
                    '  </Intersects> </And>'+
                '  </Filter>'
      return file
    },
    closePDraw(){
      this.$emit('closePDraw')
    }
   
  }
}
</script>

<style lang="less" scoped>

.searchForm{margin:15px 15px 0 5px;}
.searchBt{text-align: center;}
.formBox{position:absolute;left:10%;top:100px;background: #fff;width: 300px;padding-top:10px;z-index: 3;
.t{padding-left:10px;font-size: 16px;}
::v-deep{.el-divider--horizontal{margin-top:10px;margin-bottom:10px}
.el-date-editor.el-input, .el-date-editor.el-input__inner{width: 100%;}
}
}
</style>
